/*-----------------------------------------------------------------
- Footer
-----------------------------------------------------------------*/
export default {
    login      : 'Login',
    register   : 'Register',
    search     : 'Search',
    separator  : ' / ',
    auth_button: 'Login / Register',
    auth_avatar: 'Avatar',
};
